import { Palette, useTheme } from '@mui/material'

export const useColorPalette = (): Palette => {
  const theme = useTheme()
  return theme.palette
}
